var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFromScratch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 12.2029H33.3333C32.9211 12.2017 32.5262 12.0379 32.2347 11.7473C31.9433 11.4568 31.779 11.0631 31.7778 10.6522V6L38 12.2029Z",
    fill: "#AAC4DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 12.2029V40.1159C37.9988 40.5268 37.8345 40.9206 37.543 41.2111C37.2516 41.5017 36.8566 41.6654 36.4444 41.6667H11.5556C11.1434 41.6654 10.7484 41.5017 10.457 41.2111C10.1655 40.9206 10.0012 40.5268 10 40.1159V7.55072C10.0012 7.13982 10.1655 6.7461 10.457 6.45555C10.7484 6.165 11.1434 6.00123 11.5556 6H31.7778V10.6522C31.779 11.0631 31.9433 11.4568 32.2347 11.7473C32.5262 12.0379 32.9212 12.2017 33.3333 12.2029H38Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7333 10.8073H21.2",
    stroke: "#4C5B66",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 40.1159C38 40.5272 37.8361 40.9217 37.5444 41.2125C37.2527 41.5033 36.857 41.6667 36.4444 41.6667H11.5556C11.143 41.6667 10.7473 41.5033 10.4556 41.2125C10.1639 40.9217 10 40.5272 10 40.1159V7.55072C10 7.13945 10.1639 6.74501 10.4556 6.4542C10.7473 6.16338 11.143 6 11.5556 6H31.7778L38 12.2029V40.1159Z",
    fill: "#EDF7FF",
    stroke: "#4C5B66",
    strokeWidth: 1.86087,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0667 12.2029H33.3333C32.9207 12.2029 32.525 12.0395 32.2333 11.7487C31.9416 11.4579 31.7777 11.0635 31.7777 10.6522V6",
    stroke: "#4C5B66",
    strokeWidth: 0.930435,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromScratch);
export default __webpack_public_path__ + "static/media/from_scratch.e08389372bbdcfff1c5851fb73e015db.svg";
export { ForwardRef as ReactComponent };